export enum TradeRoutes {
  CREATE,
  CONFIRM,
  SUCCESS,
}
